<template>
  <div class="help-center-bg df">
    <div class="help-center-op0 csp ml-20">
    </div>
    <div class="help-center csp ml-20" @mouseleave="leaveHelp">
      <p class="df justify-between">
        <span class="help-center-tl">帮助中心</span>
        <span class="help-more" v-if="this.helpList.length >0">更多</span>
      </p>
      <ul class="help-list">
        <li class="help-list-item" v-for="item in helpList" :key="item.id">
          <h3 class="help-list-item-tl">{{item.title}}</h3>
          <div class="help-list-item-content">{{item.content}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      // helpList:{
      //     required: true,
      // }
    },
    data() {
      return {
        helpList: [
          {
            id: 1,
            title: "新手商家看这里",
            content:
              "了解平台操作了解平台操作技巧，发技巧，发布家居建材商品，成功案例，放不下就换行个黄想布家居建材商品，成功案例，放不下就",
          },
        ],
      };
    },
    methods: {
      leaveHelp() {
        let st = setTimeout(() => {
          this.$emit("hideCenter");
          clearTimeout(st)
        }, 500);
      },
    },
  };
</script>
<style lang="less" scoped>
  .help-center-bg {
    height: clac(100vh-100px);
  }
  .help-center-op0{
    height: 100%;
    width: 328px;
    box-sizing: border-box;
    opacity: 0;
  }
  .help-center {
    position: fixed;
    top: 80px;
    right: 20px;
    width: 328px;
    height: 100%;
    // height: clac(100vh-100px);
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    .help-center-tl {
      color: #2b3f57;
      font-weight: bold;
      font-size: 18px;
      margin: 0;
    }
    .help-more {
      font-size: 18px;
      color: #747b94;
    }
    .help-list {
      list-style: none;
      text-align: left;
      padding-left: unset;
      &-item {
        margin-top: 20px;
        &-tl {
          color: #2b3f57;
          font-size: 16px;
          font-weight: bold;
        }
        &-content {
          width: 100%;
          height: 38px;
          line-height: 19px;
          overflow: hidden;
          font-size: 14px;
          color: #747b94;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/saas/help.vue